import type { Platform, TenxMemoryRuntimeContextRefreshResult } from "@/context/platform"

const refreshTtl = 5 * 60 * 1000
const refreshes = new Map<
  string,
  {
    startedAt: number
    promise: Promise<TenxMemoryRuntimeContextRefreshResult | undefined>
  }
>()

export function refreshTenxMemoryRuntimeContextForWorkspace(
  platform: Platform,
  workspacePath: string,
  options?: { handle?: string | null },
) {
  const refresh = platform.tenxMemoryRuntimeContextRefresh
  const key = workspacePath.trim()
  if (platform.platform !== "desktop" || !refresh || !key) return Promise.resolve(undefined)
  const handle = options?.handle?.trim() ?? ""
  const refreshKey = handle ? `${key}::${handle}` : key

  const existing = refreshes.get(refreshKey)
  if (existing && Date.now() - existing.startedAt < refreshTtl) return existing.promise

  const entry = {
    startedAt: Date.now(),
    promise: Promise.resolve(undefined) as Promise<TenxMemoryRuntimeContextRefreshResult | undefined>,
  }
  entry.promise = refresh({ workspacePath: key, ...(handle ? { handle } : {}) })
    .then((result) => {
      if (result?.connected) {
        entry.startedAt = Date.now()
        return result
      }
      if (refreshes.get(refreshKey) === entry) refreshes.delete(refreshKey)
      return result
    })
    .catch(() => {
      if (refreshes.get(refreshKey) === entry) refreshes.delete(refreshKey)
      return undefined
    })
  refreshes.set(refreshKey, entry)
  return entry.promise
}
